import { get, post, _delete } from '../utils/http'

class StudyRecord {
  // 获取个人学习记录
  async getStudyRecord() {
    const res = await get('/api/content/v1/learnRecord')
    return res.data
  }
  // 删除个人学习记录
  async deleteStudyRecord(objectParentId) {
    const res = await _delete(`/api/content/v1/learnRecord/${objectParentId}`)
    return res.data
  }
  // 添加个人学习记录
  async addStudyRecord(data) {
    const res = await post('/api/content/v1/learnRecord', data)
    return res.data
  }
  // 根据课程Id获取学习记录 objectParentId(课程Id) delete=0(必传)
  async getStudyRecordById(data) {
    const res = await get(
      `/api/content/v1/learnRecord/getLatestByCondition`,
      data
    )
    return res.data
  }
  // 学习记录最新一条课程名
  async getStudyRecordLast() {
    const res = await get('/api/content/v1/learnRecord/last')
    return res.data
  }
}

export default new StudyRecord()
